import { createSlice } from '@reduxjs/toolkit';

const initialStateBHotmer = {
    listLoading: false,
    actionsLoading: false,
    bHotmer: undefined,
    bHotmerDetails: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const bHotmerSlice = createSlice({
    name: "bHotmer",
    initialState: initialStateBHotmer,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List bHotmer
        bHotmerFetched: (state, action) => {
            state.listLoading = false;
            state.bHotmer = action.payload.bHotmer;
            state.error = null;
        },
        // get bHotmer detail
        bHotmerDetailsFetched: (state, action) => {
            state.listLoading = false;
            state.bHotmerDetails = action.payload.bHotmerDetails;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.bHotmerDetails = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.bHotmer = undefined;
            state.bHotmerDetails = undefined;
            state.error = null;
            state.success = null;
        }
    }
});